import UserMachinesGrid from "./UserMachinesGrid";
import CatalogMachinesGrid from "./CatalogMachinesGrid";
import WizardParams from "./WizardParams";

/**
 * Step3MachinesPanel — orchestrator for the workshop+catalog+params step of
 * the quote wizard. Now a thin composition layer over three focused
 * sub-components (P3 refactor follow-up).
 *
 * Behaviour must stay identical to the previous monolithic version — Step 3
 * and Step 4 are explicitly out-of-scope for changes per user spec.
 */
export default function Step3MachinesPanel(props) {
  const {
    t,
    userMachines,
    selectedUserMachineIds,
    toggleUserMachine,
    otherCategoryMachines,
    ownedMachines,
    toggleMachine,
    inferEfficiency,
    batchSize,
    setBatchSize,
    marginPct,
    setMarginPct,
    currency,
    setCurrency,
    customers,
    customerId,
    setCustomerId,
    notes,
    setNotes,
  } = props;

  return (
    <div data-testid="step-machines">
      <div className="label-tech mb-2">{t("common.step")} 4</div>
      <h2 className="font-display font-bold text-xl text-slate-100 mb-1">{t("newQuote.step3Title")}</h2>
      <p className="text-slate-400 text-sm mb-6">{t("newQuote.step3Body")}</p>

      <UserMachinesGrid
        t={t}
        userMachines={userMachines}
        selectedUserMachineIds={selectedUserMachineIds}
        toggleUserMachine={toggleUserMachine}
        inferEfficiency={inferEfficiency}
      />

      <CatalogMachinesGrid
        t={t}
        otherCategoryMachines={otherCategoryMachines}
        ownedMachines={ownedMachines}
        toggleMachine={toggleMachine}
      />

      <WizardParams
        t={t}
        batchSize={batchSize}
        setBatchSize={setBatchSize}
        marginPct={marginPct}
        setMarginPct={setMarginPct}
        currency={currency}
        setCurrency={setCurrency}
        customers={customers}
        customerId={customerId}
        setCustomerId={setCustomerId}
        notes={notes}
        setNotes={setNotes}
      />
    </div>
  );
}
